import { ShieldCheck } from 'lucide-react';

import { Button, cn } from '@llura/ui';

import { useStrings } from '../hooks/useStrings';
import { useSafeExit } from '../hooks/useSafeExit';

interface SafeExitButtonProps {
  className?: string;
}

/**
 * Discreet always-visible exit affordance that lives inside the ritual
 * screens. Champagne-tinted, sits at the edge so it never competes with
 * the breathing animation. Tap → pauses any registered audio, gentle
 * haptic, routes to the calm exit screen.
 */
export function SafeExitButton({ className }: SafeExitButtonProps) {
  const { strings } = useStrings();
  const { triggerSafeExit } = useSafeExit();

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={triggerSafeExit}
      aria-label={strings.safeExit.buttonAria}
      className={cn(
        'gap-1.5 rounded-full border border-accent/40 bg-accent/10 px-3 py-1.5 text-[11px] uppercase tracking-[0.18em] text-accent-foreground hover:bg-accent/20',
        className,
      )}
    >
      <ShieldCheck className="h-3.5 w-3.5" />
      {strings.safeExit.buttonLabel}
    </Button>
  );
}
